/** Site-wide non-translated constants */

export const organizationLegalName = "Walter Media AB";
export const organizationShortName = "Walter Media";

export const organizationDetails = {
  orgNumber: "559318-9060",
  phoneDisplay: "+46 70 758 66 01",
  phoneTelHref: "tel:+46707586601",
  email: "hej@waltermedia.se",
  addressLines: ["Kronetorpsgatan 64F", "212 26 Malmö"] as const,
  /** Query-only maps URL for the registered address (footer, contact). */
  mapsSearchUrl:
    "https://www.google.com/maps/search/?api=1&query=Kronetorpsgatan+64F%2C+212+26+Malm%C3%B6%2C+Sweden",
} as const;

export const baseUrl =
  process.env.NEXT_PUBLIC_SITE_URL ?? "http://localhost:3000";

/** Default app locale (Swedish-first routing); use `useLocale()` in UI. */
export const defaultLocale = "sv" as const;

export const landingPath = "/" as const;
